// src/assets/components/ListCard.jsx
import React, { useState } from "react";
import checked from "../icons/Select/radio_checked_color.svg";
import unchecked from "../icons/Select/radio_unchecked.svg";
import uncheckable from "../icons/Select/radio_uncheckable.svg";
import { Chip } from "./Chip";

export default function ListCard({
  mode = "default",          // "default" | "checkable" | "disabled" | "uncheckable"
  icon = null,
  title,
  subtitle,
  chipLabel,
  className = "",
  onSelect,
  selected: selectedProp,
}) {
  const [innerSelected, setInnerSelected] = useState(false);

  const isSelectable = mode === "checkable";
  const isDisabled = mode === "disabled";
  const isUncheckable = mode === "uncheckable";

  const selected = selectedProp ?? innerSelected;

  const handleClick = () => {
    if (!isSelectable || isDisabled) return;

    const next = !selected;

    // 내부 상태는 외부 selected 안 넘길 때만 사용
    if (selectedProp === undefined) {
      setInnerSelected(next);
    }

    if (typeof onSelect === "function") onSelect(next);
  };

  const baseStyle =
    "w-full flex items-start rounded-[16px] p-[16px] border-[1px] transition-colors";

  const stateStyle = isDisabled
    ? "bg-surface-light-subtle border-border-subtle"
    : isUncheckable
      ? "bg-surface-light-white-layered border-border-subtle"
      : !isSelectable || !selected
        ? "bg-surface-light-white-layered border-border-default"
        : "bg-surface-light-primary-light border-border-primary";

  const clickable = isSelectable && !isDisabled ? "cursor-pointer" : "cursor-default";

  const titleClass = isUncheckable
    ? "text-t4 text-text-disabled"
    : `${selected ? "text-t4" : "text-b1"} text-text-default`;

  let leadingIcon = icon;

  if (isSelectable) {
    leadingIcon = (
      <img
        src={selected ? checked : unchecked}
        alt={selected ? "선택" : "미선택"}
        className="w-[24px] h-[24px]"
      />
    );
  } else if (isUncheckable) {
    // uncheckable 전용 아이콘
    leadingIcon = (
      <img
        src={uncheckable}
        alt="선택 불가"
        className="w-[24px] h-[24px]"
      />
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isDisabled}
      className={`${baseStyle} ${stateStyle} ${clickable} ${className}`}
    >
      {/* 왼쪽 아이콘 */}
      {leadingIcon && <div className="pr-[16px]">{leadingIcon}</div>}

      {/* 텍스트 */}
      <div className="flex flex-col text-left flex-1">
        {title && <span className={titleClass}>{title}</span>}

        {subtitle && (
          <>
            <span
              className={`pt-[4px] text-c2 ${isUncheckable ? "text-text-disabled" : "text-text-subtler"
                }`}
            >
              {subtitle}
            </span>

            {/* subtitle 아래 Chip (chip="c") */}
            {chipLabel && (
              <div className="pt-[4px]">
                <Chip chip="c" label={chipLabel} />
              </div>
            )}
          </>
        )}
      </div>
    </button>
  );
}
